import {
  DiscoveryStatusApi,
  DiscoveryApi,
  type Configuration,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/discovery';

export const discovery = (
  httpClient: HttpClient,
  config: Configuration,
  projectId: string
) => {
  const discoveryApi = new DiscoveryApi(config);
  const discoveryStatusApi = new DiscoveryStatusApi(config);

  return {
    invoke: (cloudAccountId: string) =>
      discoveryApi.invokeDiscover(projectId, cloudAccountId, {}),
    // Re-runs Google Workspace directory discovery. Takes the GWS inventory
    // resource id, not the cloud-account id.
    syncGoogleWorkspaceDirectory: (resourceId: string) =>
      discoveryApi.syncGoogleWorkspaceDirectory(projectId, resourceId),
    useStatus: (
      cloudAccountId: string,
      options?: { refreshInterval: number }
    ) =>
      httpClient.executeWithConfig(
        discoveryStatusApi.discoveryStatus.bind(discoveryStatusApi),
        cloudAccountId ? baseUrl : null,
        '/status',
        options ?? {},
        projectId,
        cloudAccountId
      ),
  };
};
